import { forwardRef, type HTMLAttributes } from 'react'

import type { RhapHoverTooltipProps } from '~/components/common/RhapHoverTooltip'

type TriggerProps = Parameters<RhapHoverTooltipProps['trigger']>[0]

type ClickableLabelSpanProps = HTMLAttributes<HTMLSpanElement> &
  Omit<TriggerProps, 'ref'>

export const ClickableLabelSpan = forwardRef<
  HTMLSpanElement,
  ClickableLabelSpanProps
>((props, ref) => <span ref={ref} {...props} />)

ClickableLabelSpan.displayName = 'ClickableLabelSpan'
